module.exports = __webpack_public_path__ + "img/AGR-i-1-III.525f13f7.png";